import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Icons } from "../../../../config/MuiIcons.config";
import AppButton from "../../../../components/CommonReusableComponent/AppButton/AppButton";
import { useSnackbar } from "../../../../contexts/Snackbar.context";
import { ERROR_MESSAGE, SNACKBAR_VARIANT } from "../../../../config/Messages.config";
import WarningImage from "../../../../assets/images/Warning.svg";

const AssignSuperAdminWarningModal = ({
  ToggleFunction,
  OnSubmit,
  LoaderState,
  Data,
}) => {
  const { showSnackbar } = useSnackbar();
  const { isOpen, type, accountId } = Data;
  return (
    <Dialog
      open={isOpen}
      // onClose={() => ToggleFunction("Delete Holiday")}
      aria-labelledby="form-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle style={{ textAlign: "center" }}>
        <IconButton
          aria-label="close"
          onClick={() => {
            ToggleFunction(false, "", null);
          }}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <Icons.Close />
        </IconButton>
        <img
          src={WarningImage}
          alt="warning-img"
          style={{ width: "45px", height: "45px" }}
        />
      </DialogTitle>
      <DialogContent style={{ textAlign: "center" }}>
        <Typography style={{ fontSize: "24px" }} className="inter-regular-400">
          Are you sure
        </Typography>
        <Typography style={{ fontSize: "16px" }} className="inter-regular-400">
          {type === "ADD"
            ? "Do you want to assign Zingworks Super Admin to this account?"
            : "Do you want to remove Zingworks Super Admin from this account?"}
        </Typography>
      </DialogContent>
      <DialogActions className="justify-content-center mb-3 mx-5">
        <AppButton
          Color={"error"}
          OnPress={() => {
            ToggleFunction(false, "", null);
          }}
        >
          Cancel
        </AppButton>
        <AppButton
          OnPress={() => {
            if (navigator.onLine) {
              OnSubmit(accountId);
            } else {
              showSnackbar(
                ERROR_MESSAGE.INTERNET_ERROR,
                SNACKBAR_VARIANT.ERROR
              );
            }
          }}
          LoadingState={LoaderState}
          IsDisabled={LoaderState}
        >
          {type === "ADD" ? "Assign" : "Remove Assignee"}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default AssignSuperAdminWarningModal;
